export default function getNewTime(time: string, frequency: string, baseTime?: string) {
  const fillDate = (val: string | null, idx: number) => {
    if (val != null) {return val;}

    const repetition = idx === 0 ? 4 : 2;
    return '1'.padStart(repetition, '0');
  };

  const [ year, month, day ] = time.split('-');
  const [ baseYear, baseMonth, baseDay ] = baseTime ? baseTime.split('-') : [];

  switch (frequency) {
  case 'mon':
    return [year ?? baseYear, month ?? baseMonth].map(fillDate).join('-');
  case 'day':
    return [year ?? baseYear, month ?? baseMonth, day ?? baseDay].map(fillDate).join('-');
  case 'ye':
    return [year ?? baseYear].map(fillDate).join('-');
  default:
    throw new Error(`Unsupported frequency value: ${frequency}`);
  }
}
